<template>
    <div>
        <router-link
            class="map-brand"
            to="/visor"
            title="Volver al inicio"
            aria-label="Visor GRD: volver al inicio"
        >
            <img
                src="@/assets/img/logo_visor_grd.png"
                alt="Visor GRD, Gestión del Riesgo de Desastres"
            />
        </router-link>

        <!-- Botón Menú (Arriba Derecha) -->
        <button @click="toggleDrawer" class="btn-control btn-menu">
            <i class="fas fa-bars"></i>
        </button>

        <!-- Controles del mapa (debajo del logo) -->
        <div class="map-controls">
            <!--Tooltips agregados segun observacion SENAPRED 06/2026 ("No tiene tooltip")-->
            <button @click="zoomIn" class="btn-control" title="Acercar Imagen">
                <!--iconos cambiado segun observaciones SENAPRED 06/2026 ("No tiene tooltip. El símbolo no está centrado verticalmente")-->
                <i class="fas fa-plus"></i>
            </button> 
            <button @click="zoomOut" class="btn-control" title="Alejar Imagen">
                <!--iconos cambiado segun observaciones SENAPRED 06/2026 ("No tiene tooltip. El símbolo no está centrado verticalmente")-->
                <i class="fas fa-minus"></i>
            </button>
            <button @click="resetView" class="btn-control" title="Vista Inicial">
                <i class="fas fa-home"></i>
            </button>
            <div class="geo-btn-wrapper">
                <button @click="geolocate" class="btn-control" :class="{ active: geolocating || geoActive }" title="Mi Ubicación">
                    <i :class="geolocating ? 'fas fa-spinner fa-spin' : 'fas fa-crosshairs'"></i>
                </button>
                <div v-if="geoError" class="geo-error" role="alert">{{ geoError }}</div>
            </div>
            <button @click="toggleFullscreen" class="btn-control" title="Full Extent">
                <i class="fas fa-expand"></i>
            </button>
            <button
                @click="toggleBoxZoom"
                class="btn-control"
                :class="{ active: boxZoomActive }"
                :aria-pressed="boxZoomActive"
                title="Acercar por área"
            >
                <svg class="box-zoom-icon" viewBox="0 0 24 24" aria-hidden="true">
                    <circle cx="9.5" cy="9.5" r="6.5" />
                    <rect x="6" y="6" width="7" height="7" />
                    <line x1="14.25" y1="14.25" x2="21" y2="21" />
                </svg>
            </button>
        </div>
    </div>
</template>

<script>
import { mapCustomControlsService } from "@/services/map/mapCustomControlsService";

export default {
    name: "MapControlsCustom",

    data() {
        return {
            boxZoomActive: false,
            geolocating: false,
            geoActive: false,
            geoError: '',
            geoAttempt: 0,
            geoTimer: null,
            geoErrorTimer: null,
        };
    },

    methods: {
        toggleDrawer() {
            this.$store.dispatch('setMapControlSelection', {
                control: 'navDrawer',
                active: true
            });
        },
        zoomIn() {
            mapCustomControlsService.zoomIn();
        },
        zoomOut() {
            mapCustomControlsService.zoomOut();
        },
        resetView() {
            mapCustomControlsService.resetView();
        },
        geolocate() {
            if (this.geolocating) return;
            if (this.geoActive) {
                this.deactivateGeolocation();
                return;
            }
            this.clearGeoTimers();
            this.geoError = '';
            this.geolocating = true;
            // Cada intento lleva su numero: si el usuario reintenta mientras hay un
            // getCurrentPosition anterior sin resolver, el callback tardio del viejo
            // llegaba igual y pisaba el estado del nuevo.
            const attempt = ++this.geoAttempt;
            // El timeout de la Geolocation API no corre mientras el navegador espera que el
            // usuario responda el permiso: si no lo responde nunca, no llega ningún callback y el
            // botón quedaba con el spinner girando para siempre. Respaldo para liberarlo.
            this.geoTimer = setTimeout(() => {
                this.geoTimer = null;
                this.failGeolocate(attempt, 'El navegador no respondió. Revisa si quedó pendiente el permiso de ubicación.');
            }, 15000);
            mapCustomControlsService.locate(
                () => this.succeedGeolocate(),
                (msg) => this.failGeolocate(attempt, msg)
            );
        },
        succeedGeolocate() {
            // Sin numero de intento: locate() ya dibujo el pin, asi que el exito vale
            // aunque venga de un intento anterior. Descartarlo dejaba el punto en el
            // mapa con geoActive en false, o sea sin forma de borrarlo.
            this.geoAttempt++;
            this.clearGeoTimers();
            this.geolocating = false;
            this.geoError = '';
            this.geoActive = true;
        },
        failGeolocate(attempt, msg) {
            if (attempt !== this.geoAttempt) return;
            this.clearGeoTimers();
            this.geolocating = false;
            this.geoError = msg;
            this.geoErrorTimer = setTimeout(() => { this.geoError = ''; }, 7000);
        },
        deactivateGeolocation() {
            mapCustomControlsService.clearGeolocation();
            this.geoActive = false;
        },
        clearGeoTimers() {
            clearTimeout(this.geoTimer);
            clearTimeout(this.geoErrorTimer);
            this.geoTimer = null;
            this.geoErrorTimer = null;
        },
        toggleFullscreen() {
            mapCustomControlsService.toggleFullscreen();
        },
        toggleBoxZoom() {
            if (this.boxZoomActive) {
                mapCustomControlsService.deactivateBoxZoom();
                this.boxZoomActive = false;
                return;
            }

            this.boxZoomActive = mapCustomControlsService.activateBoxZoom(() => {
                this.boxZoomActive = false;
            });
        }
    },
    beforeDestroy() {
        this.clearGeoTimers();
        mapCustomControlsService.deactivateBoxZoom();
    }
};
</script>

<style scoped>
.map-brand {
    position: absolute;
    top: 20px;
    left: 24px;
    width: 170px;
    z-index: 2000;
    opacity: 0.68;
    transition: opacity 160ms ease;
}

.map-brand img {
    display: block;
    width: 100%;
    height: auto;
}

.map-brand:hover,
.map-brand:focus {
    opacity: 1;
}

.map-brand:focus-visible {
    outline: 2px solid var(--color-orange);
    outline-offset: 5px;
    border-radius: 2px;
}

.map-controls {
    position: absolute;
    left: 36px;
    top: 130px;
    display: flex;
    flex-direction: column;
    gap: 3px;
    z-index: 2000;
}

.btn-menu {
    position: absolute;
    top: 24px;
    right: 20px;
    z-index: 2000;
}

.btn-control {
    width: 28px;
    height: 28px;
    background: var(--color-navy);
    border: none;
    border-radius: 4px;
    color: var(--color-white);
    font-size: 14px;
    cursor: pointer;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
}

.btn-control:hover {
    background: var(--color-steel);
}

button.btn-menu {
    width: 44px;
    height: 44px;
    font-size: 24px;
}

.btn-control.active {
    background: var(--color-orange);
}

.geo-btn-wrapper {
    position: relative;
}

.geo-error {
    position: absolute;
    left: calc(100% + 8px);
    top: 50%;
    transform: translateY(-50%);
    background: #b91c1c;
    color: #fff;
    padding: 5px 9px;
    border-radius: 4px;
    font-size: 0.73rem;
    max-width: 220px;
    line-height: 1.35;
    z-index: 2001;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
    pointer-events: none;
}

.box-zoom-icon {
    width: 15px;
    height: 15px;
    fill: none;
    stroke: currentColor;
    stroke-width: 1.8;
    stroke-linecap: round;
    stroke-linejoin: round;
}

@media only screen and (max-width: 640px) {
    .map-brand {
        top: 18px;
        left: 18px;
        width: 145px;
    }

    .map-controls {
        top: 98px;
        left: 30px;
    }

    .btn-menu {
        top: 18px;
        right: 18px;
    }
}
</style>
